<mat-spinner *ngIf="loading" libCustomSpinner color="#ddd" strokeWidth="2" diameter="60"></mat-spinner>
<ng-container *ngIf="adRunning">
  <button  mat-icon-button
           class="bitmovin-player__ad-control"
           style="left: 16px"
           [class.play]="!playerApi.isPlaying()"
           [class.pause]="playerApi.isPlaying()"
           (click)="togglePlay()">
  </button>
  <button mat-icon-button
          class="bitmovin-player__ad-control"
          style="left: 50px"
          [class.mute]="!playerApi.isMuted()"
          [class.unmute]="playerApi.isMuted()"
          (click)="toggleMute()">
  </button>
</ng-container>

<div #bmPlayerComponent
     inViewport
     (inViewportAction)="onViewportChange($event)"
     class="bitmovin-player__container"
     [class.hidden]="loading"
     (click)="onPlayerClick($event)">
  <button
    mat-icon-button
    class="bitmovin-player__seek-backward"
    [class.hidden]="loading || adRunning || !showControls"
    [class.fullscreen]="isFullscreen"
    (click)="seek(-10)"
  >
    <mat-icon>replay_10</mat-icon>
  </button>
  <button
    mat-icon-button
    class="bitmovin-player__pause"
    [class.hidden]="loading || adRunning || !showControls || !isPlaying()"
    [class.fullscreen]="isFullscreen"
    (click)="togglePlay()"
  >
    <mat-icon>pause</mat-icon>
  </button>
  <button 
    mat-icon-button
    class="bitmovin-player__seek-forward"
    [class.hidden]="loading || adRunning || !showControls"
    [class.fullscreen]="isFullscreen"
    (click)="seek(10)"
  >
    <mat-icon>forward_10</mat-icon>
  </button>
</div>
